import React from 'react';
import Navbar from '../../../../components/Navbar';
import Header from '../../../../components/Header';
import FormPengajuanKUM from './Section';

const PengajuanKUM = () => (
  <>
    <Navbar />
    <Header />
    <FormPengajuanKUM />
  </>
);

export default PengajuanKUM;
